import { useTranslation } from 'react-i18next';

import { BlueprintBuilder } from '@/features/blueprint/BlueprintBuilder';

export function BlueprintPage() {
  const { t } = useTranslation('blueprint');
  return (
    <div className="flex flex-col gap-4">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight text-ink">{t('title')}</h1>
        <p className="mt-1 text-sm text-ink-muted">{t('subtitle')}</p>
      </header>
      <BlueprintBuilder />
    </div>
  );
}
